var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      {
        directives: [
          {
            name: "htmlclass",
            rawName: "v-htmlclass",
            value: { "show--custom-dropdown": _vm.customDropdownOpen },
            expression: "{'show--custom-dropdown': customDropdownOpen}"
          }
        ],
        staticClass: "select-input",
        class: {
          "select-input--disabled": _vm.disabled,
          "select-input--focused": _vm.focused,
          "select-input--error": _vm.error,
          "select-input--empty": !_vm.options.length,
          "select-input--no-selection": !_vm.value,
          "select-input--custom-dropdown-open": _vm.customDropdownOpen,
          "select-input--custom-dropdown-top": _vm.customDropdownTop
        },
        attrs: { tabindex: _vm.customDropdownEnabled ? 0 : -1 }
      },
      _vm.customDropdownEnabled
        ? {
            focus: _vm.onFocusCustom,
            focusout: _vm.onBlurCustom,
            keydown: _vm.onKeydownCustom,
            click: _vm.onValueClickCustom
          }
        : {}
    ),
    [
      _c("FormInput", {
        attrs: {
          value: _vm.computedValue,
          label: _vm.label,
          "label-option": _vm.labelOption,
          placeholder: _vm.label,
          readonly: "",
          disabled: _vm.disabled,
          error: _vm.error
        }
      }),
      _vm._v(" "),
      _vm.customDropdownEnabled
        ? _c(
            "ul",
            {
              ref: "dropdown",
              staticClass: "select-input__dropdown",
              on: {
                mouseenter: _vm.onDropdownMouseEnter,
                mouseleave: _vm.onDropdownMouseLeave
              }
            },
            [
              _vm._l(_vm.options, function(option, index) {
                return [
                  option.group
                    ? [
                        _c("li", {
                          key: option.label,
                          staticClass: "select-input__dropdown-group",
                          domProps: { innerHTML: _vm._s(option.label) }
                        }),
                        _vm._v(" "),
                        _vm._l(option.options, function(opt, key) {
                          return _c("li", {
                            key: opt.value,
                            ref: "dropdownOption",
                            refInFor: true,
                            staticClass:
                              "select-input__dropdown-option select-input__dropdown-option--grouped",
                            class: {
                              "select-input__dropdown-option--disabled": !!opt.disabled,
                              "select-input__dropdown-option--selected":
                                opt.value === _vm.value,
                              "select-input__dropdown-option--hover":
                                _vm.allOptions.findIndex(function(option) {
                                  return option.value == opt.value
                                }) === _vm.customDropdownHover
                            },
                            attrs: {
                              "data-value": opt.value,
                              disabled: !!opt.disabled
                            },
                            domProps: {
                              innerHTML: _vm._s(opt.label || opt.value)
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.onOptionClickCustom($event, opt)
                              },
                              mouseover: function($event) {
                                return _vm.onOptionHoverCustom(
                                  $event,
                                  opt,
                                  index + "-" + key
                                )
                              }
                            }
                          })
                        })
                      ]
                    : _c("li", {
                        key: option.value,
                        ref: "dropdownOption",
                        refInFor: true,
                        staticClass: "select-input__dropdown-option",
                        class: {
                          "select-input__dropdown-option--disabled": !!option.disabled,
                          "select-input__dropdown-option--selected":
                            option.value === _vm.value,
                          "select-input__dropdown-option--hover":
                            index === _vm.customDropdownHover
                        },
                        attrs: {
                          "data-value": option.value,
                          disabled: !!option.disabled
                        },
                        domProps: {
                          innerHTML: _vm._s(option.label || option.value)
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.onOptionClickCustom($event, option)
                          },
                          mouseover: function($event) {
                            return _vm.onOptionHoverCustom(
                              $event,
                              option,
                              index
                            )
                          }
                        }
                      })
                ]
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.customDropdownEnabled
        ? _c(
            "select",
            {
              ref: "input",
              staticClass: "select-input__select",
              attrs: {
                id: _vm.id,
                name: _vm.name,
                required: _vm.required,
                disabled: _vm.disabled || _vm.readonly
              },
              domProps: { value: _vm.value },
              on: { change: _vm.onInput, focus: _vm.onFocus, blur: _vm.onBlur }
            },
            [
              _c("option", {
                attrs: { value: "", disabled: "" },
                domProps: { innerHTML: _vm._s(_vm.label) }
              }),
              _vm._v(" "),
              _vm._l(_vm.options, function(option) {
                return [
                  option.group
                    ? _c(
                        "optgroup",
                        { key: option.label, attrs: { label: option.label } },
                        _vm._l(option.options, function(opt) {
                          return _c("option", {
                            key: opt.value,
                            attrs: { disabled: !!opt.disabled },
                            domProps: {
                              value: opt.value,
                              innerHTML: _vm._s(opt.label || opt.value)
                            }
                          })
                        }),
                        0
                      )
                    : _c("option", {
                        key: option.value,
                        attrs: { disabled: !!option.disabled },
                        domProps: {
                          value: option.value,
                          innerHTML: _vm._s(option.label || option.value)
                        }
                      })
                ]
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }